import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';

/** What the signed-in user may do on the dispatch screens. UX only: the server stays the authority. */
export function useDispatchPermissions() {
  const { state } = useCurrentUser();
  const has = (permission: string) => state.status === 'authenticated' && state.user.permissions.includes(permission);

  return {
    canDispatch: has('trip.dispatch'),
    canApproveOverrides: has('override.approve'),
    canViewFleet: has('fleet.view'),
    canViewJobs: has('job.view'),
    canTopUp: has('advance.issue'),
    canViewCash: has('driver_ledger.view'),
    canRecordCash: has('driver_ledger.record'),
    canDecideAccessorials: has('trip_accessorial.decide'),
  };
}
